import { render, staticRenderFns } from "./reviewGuide.vue?vue&type=template&id=3322dde5&scoped=true"
import script from "./reviewGuide.vue?vue&type=script&lang=js"
export * from "./reviewGuide.vue?vue&type=script&lang=js"
import style0 from "./reviewGuide.vue?vue&type=style&index=0&id=3322dde5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322dde5",
  null
  
)

export default component.exports